import { FC } from 'react';
import { IncidentDetailPatient } from 'sections/ube/features/IncidentDetail/useIncidentDetailForUbe';
import { UbePatientDetailTabKey } from '..';
import { BaseInfoView } from './BaseInfoView';
import { RequestSummaryView } from './RequestSummaryView';
import { VitalsView } from './VitalsView';
import { FindingsEmsTeamContactView } from './FindingsEmsTeamContactView';
import { TreatmentView } from './TreatmentView';
import { SpecialTreatmentView } from './SpecialTreatmentView';
import { SpecialTreatmentTimeSeriesView } from './SpecialTreatmentTimeSeriesView';
import { Photo } from 'core/components/JianDetail/PatientDetailInfo/Photo';
import { ActivityRecordPdf } from 'core/components/JianDetail/PatientDetailInfo/ActivityRecordPdf';
import { PrognosisInfo } from 'core/components/JianDetail/PatientDetailInfo/PrognosisInfo';
import { AcceptRequestHistory } from 'core/components/JianDetail/PatientDetailInfo/AcceptRequestHistory';
import { ListVideos } from 'core/components/JianDetail/PatientDetailInfo/Video';

type Props = {
  patient: IncidentDetailPatient;
  destinationHospitalId?: string | null;
  selectedTab: UbePatientDetailTabKey;
};

export const PatientDetailSection: FC<Props> = ({
  patient,
  destinationHospitalId,
  selectedTab,
}) => {
  return (
    <div className="pt-[24px] pb-[40px]">
      <div className="max-w-[1280px] px-[40px] m-auto">
        {selectedTab === 'baseInfo' && (
          <BaseInfoView baseInfo={patient.baseInfo} />
        )}
        {selectedTab === 'requestSummary' && (
          <RequestSummaryView requestSummary={patient.requestSummary} />
        )}
        {selectedTab === 'vitals' && <VitalsView vitals={patient.vitals} />}
        {selectedTab === 'findEmsContact' && (
          <FindingsEmsTeamContactView
            findingsEmsTeamContact={patient.findingsEmsContact}
          />
        )}
        {/* 宇部の処置は配列だが最大要素数は1つ */}
        {selectedTab === 'treatment' && (
          <TreatmentView treatment={patient.treatments[0]} />
        )}
        {selectedTab === 'specialTreatment' && (
          <SpecialTreatmentView
            specialTreatment={patient.treatments[0]?.data}
          />
        )}
        {selectedTab === 'specialTreatmentTimeSeries' && (
          <SpecialTreatmentTimeSeriesView
            roscData={patient.treatments[0]?.data?.roscData}
          />
        )}
        {selectedTab === 'photo' && <Photo images={patient.imageIds} />}
        {selectedTab === 'video' && (
          <ListVideos videoList={patient.videoList} />
        )}
        {selectedTab === 'acceptRequestHistory' && (
          <AcceptRequestHistory
            acceptRequestHistory={patient.acceptRequestHistory}
          />
        )}
        {selectedTab === 'activityRecordPdf' && (
          <ActivityRecordPdf activityRecordPdf={patient.activityRecordPdf} />
        )}
        {selectedTab === 'prognosisInfo' && (
          <PrognosisInfo
            destinationHospitalId={destinationHospitalId}
            patientId={patient.id}
          />
        )}
      </div>
    </div>
  );
};
